export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm0-2a1.25 1.25 0 100-2.5A1.25 1.25 0 009 14zM6 6.75C6 5.23 7.35 4 9 4s3 1.23 3 2.75c0 1.11-.66 1.77-1.19 2.29-.53.53-.81.83-.81 1.46H8c0-1.48.8-2.28 1.388-2.868L9.4 7.62c.44-.43.6-.61.6-.87C10 6.34 9.54 6 9 6s-1 .34-1 .75H6z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};